import config from 'config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    getGroupMembers: {
        url: `${customerApi}/api/group_chat/{id}/member/search`,
        type: 'POST',
    },
    getGroupDetail: {
        url: `${customerApi}/api/group_chat/{id}`,
        type: 'GET',
    },

    // 获取群分组
    getGroupGrouping: {
        url: `${customerApi}/api/group_chat_category`,
        type: 'GET',
    },

    // 群搜索
    chatGroupsSearch: {
        url: `${customerApi}/api/group_chat/search`,
        type: 'POST',
    },
}
